import UserColorOption from 'components/ui/ColorOption';
import { ADMIN_ACCENT_PRIMARY, ADMIN_SURFACE_6 } from 'style/constants';
import styled from 'styled-components';

const ColorOption = styled(UserColorOption)`
  border: 1.5px solid ${({ selected }) => selected ? ADMIN_ACCENT_PRIMARY : ADMIN_SURFACE_6};
`;

export default ColorOption;
